import baseCharacterMaleStandPose1Asset from "@assets/base_character_v2/poses/male_stand_pose_1.fbx";
import baseCharacterMaleStandPose2Asset from "@assets/base_character_v2/poses/male_stand_pose_2.fbx";
import baseCharacterMaleStandPoseShyAsset from "@assets/base_character_v2/poses/male_stand_pose_shy.fbx";
import baseCharacterFemaleStandPose1Asset from "@assets/base_character_v2/poses/female_stand_pose_1.fbx";
import baseCharacterFemaleStandPose2Asset from "@assets/base_character_v2/poses/female_stand_pose_2.fbx";
import baseCharacterFemaleStandPoseShyAsset from "@assets/base_character_v2/poses/female_stand_pose_shy.fbx";

export const BaseMaleCharacterPosesAssetMap = {
  baseCharacterMaleStandPose1: {
    fileName: baseCharacterMaleStandPose1Asset,
  },
  baseCharacterMaleStandPose2: {
    fileName: baseCharacterMaleStandPose2Asset,
  },
  baseCharacterMaleStandPoseShy: {
    fileName: baseCharacterMaleStandPoseShyAsset,
  },
};

export const BaseFemaleCharacterPosesAssetMap = {
  baseCharacterFemaleStandPose1: {
    fileName: baseCharacterFemaleStandPose1Asset,
  },
  baseCharacterFemaleStandPose2: {
    fileName: baseCharacterFemaleStandPose2Asset,
  },
  baseCharacterFemaleStandPoseShy: {
    fileName: baseCharacterFemaleStandPoseShyAsset,
  },
};
